import { useCallback } from 'react';

import Cookies from 'js-cookie';

import { usePageContent } from './usePageContent';

export function useFlowBasketHelper() {
  const { flowName } = usePageContent();

  const basketName = `${flowName?.toLowerCase()}_basket`;

  const removeBasket = useCallback(() => {
    if (basketName) {
      Cookies.remove(basketName);
    }
  }, [basketName]);

  return { removeBasket };
}
